<template>
    <BaseForm v-if="project && errors">
        <template #fields>
            <TextAreaField
                :value="values.locationRequirements"
                :label="$t('location-requirements')"
                :error-messages="errors.locationRequirements"
                :max-length="ProjectSeriesLocationSchema.shape.locationRequirements.maxLength ?? undefined"
                @input="setFieldValue('locationRequirements', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('locationRequirements', true)"
            />
            <TextAreaField
                :value="values.allocationHints"
                :label="$t('allocation-hints')"
                :error-messages="errors.allocationHints"
                :max-length="ProjectSeriesLocationSchema.shape.allocationHints.maxLength ?? undefined"
                @input="setFieldValue('allocationHints', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('allocationHints', true)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import TextAreaField from '@/components/Form/TextAreaField.vue';
import { useForm } from '@/forms/composables/useForm';
import { useProjectInjection } from '@/project/composables/useProjectInjection';
import { ProjectLocationSchema, ProjectSeriesLocationSchema } from '@/project/schemas';
import { computed } from 'vue';
const props = defineProps<{ projectId: string }>();

const projectId = computed(() => props.projectId);

const { project, updateProject } = useProjectInjection();

const { values, errors, setFieldValue, setFieldTouched, validate, onDiscard, resetForm } = useForm(
    ProjectLocationSchema,
    computed(() => ({
        locationRequirements: project.value?.locationRequirements ?? '',
        allocationHints: project.value?.allocationHints ?? '',
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await updateProject({ id: projectId.value, ...values.value });
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
